// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2pv8DNNb6kG8cApLa-Vget"};